import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  // Close on Escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  // Close on click outside
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
      onClose();
    }
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-[#2E2E2E]/60 backdrop-blur-sm transition-all duration-300" onClick={handleBackdropClick} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-237">
      <div ref={modalRef} className="bg-[#FDFBF9] w-full max-w-2xl max-h-[85vh] rounded-xl shadow-2xl flex flex-col animate-in fade-in zoom-in-95 duration-200" data-id="element-238">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-[#2E2E2E]/10" data-id="element-239">
          <h2 id="modal-title" className="text-2xl font-bold text-[#2E2E2E] font-['Poppins']" data-id="element-240">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-[#2E2E2E]/5 text-[#2E2E2E] transition-colors focus:outline-none focus:ring-2 focus:ring-[#0D3B66]" aria-label="Cerrar modal" data-id="element-241">
            <X className="w-6 h-6" data-id="element-242" />
          </button>
        </div>

        {/* Content - Scrollable */}
        <div className="p-6 overflow-y-auto custom-scrollbar text-[#2E2E2E]/80 leading-relaxed font-['Open_Sans']" data-id="element-243">
          {children}
        </div>
      </div>
    </div>;
}